(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["etg-collections-page"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var chips = document.querySelectorAll('.etg-chip');
    var groups = document.querySelectorAll('.etg-group');

    if (!chips.length || !groups.length) return;

    chips.forEach(function(chip) {
      chip.addEventListener('click', function() {
        var filter = this.dataset.filter;

        // Update active chip
        chips.forEach(function(c) { c.classList.remove('etg-chip--active'); });
        this.classList.add('etg-chip--active');

        // Show/hide groups
        groups.forEach(function(group) {
          if (filter === 'all' || group.dataset.group === filter) {
            group.style.display = '';
          } else {
            group.style.display = 'none';
          }
        });

        // Scroll to body
        var body = document.querySelector('.etg-cp__body');
        if (body) {
          body.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["etg-contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var topicGrid  = document.getElementById('etgTopicGrid');
    var orderField = document.getElementById('etgOrderField');
    var topicInput = document.getElementById('etgTopicInput');

    if (topicGrid) {
      topicGrid.addEventListener('click', function (e) {
        var card = e.target.closest('.etg-topic-card');
        if (!card) return;
        topicGrid.querySelectorAll('.etg-topic-card').forEach(function (c) {
          c.classList.remove('etg-topic-active');
        });
        card.classList.add('etg-topic-active');
        var topic = card.dataset.topic;
        if (topicInput) topicInput.value = topic;
        if (orderField) {
          if (topic === 'ORDER HELP') {
            orderField.removeAttribute('hidden');
          } else {
            orderField.setAttribute('hidden', '');
          }
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
